import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-inline-flex align-items-center" }
const _hoisted_2 = ["onClick"]

import Dictionary from "~/ts/library/Dictionary";
import CoreUiHtmlify from "~/core-ui/vue/ui/CoreUiHtmlify.vue";
import CoreUiOperatorAvatar from "~/core-ui/vue/chat/CoreUiOperatorAvatar.vue";
import CoreUiChatClientAvatar from "~/core-ui/vue/chat/CoreUiChatClientAvatar.vue";
import {CoreUiChatHistoryActionsInterface} from "~/core-ui/vue/chat/CoreUiChatHistoryActions";
import {ref, computed} from "vue";
import {__} from "~/ts/library/Translate";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "CoreUiChatHistoryMessageReactionList"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    message: {},
    client: {},
    operatorsDictionary: {},
    you: {},
    messageActions: {}
  },
  setup(__props: any) {

let props = __props;

let overrideReactions = ref<OperatorApplicationApi.MessageReactionOpenApiModel[]>();

function isRemovable(reaction: OperatorApplicationApi.MessageReactionOpenApiModel): boolean {
    return !!(props.you && props.you.login == reaction.operatorLogin && props.messageActions?.setMessageReaction);
}

async function remove(reaction: OperatorApplicationApi.MessageReactionOpenApiModel) {
    if (isRemovable(reaction)) {
        overrideReactions.value = reactions.value.filter(item => item !== reaction);
        await props.messageActions?.setMessageReaction(props.message, null);
        overrideReactions.value = null;
    }
}

let reactions = computed(() => {
    if (overrideReactions.value) {
        return overrideReactions.value;
    }
    return props.message.reactions;
});

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reactions), (reaction) => {
      return (_openBlock(), _createBlock(_component_el_tag, {
        type: "primary",
        class: "message-reaction-tag"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", {
              class: "d-inline-block emoji",
              onClick: ($event: any) => (remove(reaction))
            }, [
              _createVNode(CoreUiHtmlify, {
                style: {"font-size":".8em"},
                emoji: "",
                value: reaction.emoji,
                class: _normalizeClass({
                            'cursor-pointer': isRemovable(reaction)
                        })
              }, null, 8, ["value", "class"])
            ], 8, _hoisted_2),
            (reaction.isFromOperator && __props.operatorsDictionary[reaction.operatorLogin])
              ? _withDirectives((_openBlock(), _createBlock(CoreUiOperatorAvatar, {
                  key: 0,
                  operator: __props.operatorsDictionary[reaction.operatorLogin],
                  "show-status": false,
                  size: "1.5em"
                }, null, 8, ["operator"])), [
                  [_directive_my_tooltip, __props.operatorsDictionary[reaction.operatorLogin].fio]
                ])
              : (reaction.isFromClient && __props.client)
                ? _withDirectives((_openBlock(), _createBlock(CoreUiChatClientAvatar, {
                    key: 1,
                    client: __props.client,
                    size: "1.5em"
                  }, null, 8, ["client"])), [
                    [_directive_my_tooltip, _unref(__)('Клиент')]
                  ])
                : _createCommentVNode("", true)
          ])
        ]),
        _: 2
      }, 1024))
    }), 256))
  ]))
}
}

})